import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentRechner, ICurrentRechner, IProduktseite } from '../../../shared/rechner';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  rechner: Observable<ICurrentRechner> = this.currentRechner.getRechner();
  produktseite: Observable<IProduktseite> = this.currentRechner.getProduktseite();

  constructor(private currentRechner: CurrentRechner) { }
}
